export const LIST_SAVED_CARDS = 'LIST_SAVED_CARDS';
export const DELETE_SAVED_CARD = 'DELETE_SAVED_CARD';